import UserLoggedService from "@/services/resources/UserLoggedService";
import router from "@/router/index";
import store from '@/store/index';
import EmailVerificationService from "@/services/resources/EmailVerificationService";
import ClubService from "@/services/resources/ClubService";
import SubUserService from "@/services/resources/SubUsersService";
import TopbarService from "@/services/resources/TopbarService";
import ObservabilityService from "@/services/observability/ObservabilityService";
import { safeParseJSON } from "@/utils/safeParseJSON";

const serviceSubUser = SubUserService.build();
const service = UserLoggedService.build();

export default {
  userRequest: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      service
        .get("")
        .then((resp) => {
          commit("userSuccess", resp);
          //dispatch('redirectUserToHome')
          window.localStorage.id_user_greenn = resp.id;

          // Sentry — identifica o seller em todos os eventos a partir do login
          ObservabilityService.setUser({ id: resp.id, name: resp.name, email: resp.email });

          // Ensure the has_sales_permission is also updated in subUser if active
          if (localStorage.getItem("subUser")) {
              let subUser = safeParseJSON("subUser");
              if (subUser && resp.has_sales_permission !== undefined) {
                  subUser.has_sales_permission = resp.has_sales_permission;
                  localStorage.setItem("subUser", JSON.stringify(subUser));
              }
          }
          
          resolve(resp);
        })
        .catch((err) => {
          commit("userError");
          reject(err);
          // if resp is unauthorized, logout, to
          // dispatch('authLogout')
        });
    });
  },
  getPanels: ({ commit, getters }, requestConfig = {}) => {
    const skipParentContext = getters && getters.isClientOnly === true;

    return new Promise((resolve, reject) => {
      serviceSubUser
        .get("/panels", {
          // A descoberta de painéis é opcional para comprador Client-only.
          // Um 403 nesse bootstrap não deve gerar toast.
          suppressErrorNotify: true,
          ...requestConfig,
          // Para Client-only, a lista é bootstrap sem contexto. Um cookie
          // stale não pode transformar um ID arbitrário em header de painel.
          skipParentContext: skipParentContext || requestConfig.skipParentContext === true,
        })
        .then((resp) => {
          const panels = Array.isArray(resp) ? resp : [];
          commit("setAvailablePanels", panels);
          resolve(panels);
        })
        .catch((err) => {
          commit("setAvailablePanels", []);
          reject(err);
        });
    });
  },
  bootstrapSubUserPanel: ({ dispatch, commit, getters }) => {
    // Seller/Admin já passam pelo middleware sem precisar de contexto pai.
    // Para Client-only, primeiro descobrimos os painéis e só então enviamos
    // X-Parent-User-ID nas chamadas protegidas seguintes.
    if (!getters.isClientOnly || getters.setPanel) {
      return Promise.resolve(null);
    }

    return dispatch("getPanels")
      .then((panels) => {
        if (!Array.isArray(panels)) {
          return null;
        }

        const userId = getters.getProfile && getters.getProfile.id;
        const eligiblePanels = panels.filter((panel) => {
          const hasSellerRole = Array.isArray(panel.roles) && panel.roles.some(
            (role) => role.name === "Seller" || role.name === "Admin",
          );
          const hasOwnConfirmedRelation = Array.isArray(panel.sub_user_parent)
            && panel.sub_user_parent.some(
              (relation) => String(relation.child_user_id) === String(userId)
                && String(relation.parent_user_id) === String(panel.id)
                && (relation.child_confirmed === true || relation.child_confirmed === 1 || relation.child_confirmed === '1')
                && (relation.parent_confirmed === true || relation.parent_confirmed === 1 || relation.parent_confirmed === '1'),
            );

          return panel.id && String(panel.id) !== String(userId)
            && hasSellerRole
            && hasOwnConfirmedRelation;
        });

        // Com mais de um pai, a escolha continua explícita no seletor de
        // painéis. O caso de um único pai pode ser inicializado com segurança.
        if (eligiblePanels.length !== 1) {
          return null;
        }

        commit("setPanel", eligiblePanels[0]);
        return eligiblePanels[0];
      })
      .catch(() => null);
  },
  setPanel: (context, payload) => {
    if (
      !payload
      || payload.id == null
      || (
        context.getters.isClientOnly
        && !context.getters.isPanelAuthorized(payload.id)
      )
    ) {
      return Promise.resolve(null);
    }

    context.commit("setPanel", payload);
    return Promise.resolve(payload);
  },
  resetPanel: (context, payload) => {
    context.commit("resetPanel");
  },
  emailVerification: ({ commit, dispatch }) => {
    if (store.getters.isAuthenticated) {
      const serviceEmail = EmailVerificationService.build();
      return new Promise((resolve, reject) => {
        serviceEmail
          .get("/check-user")
          .then((resp) => {
            if (resp.verified === false) {
              dispatch("redirectUserVerification");
            }
            commit("verifyEmail", resp.verified);
            resolve(resp.verified);
          })
          .catch((err) => {
            commit("userError");
            reject(err);
          });
      });
    } else {      
      router.push(`/`);
    }
  },
  clubVerification: ({ commit, dispatch }) => {
    const serviceClub = ClubService.build();
    return new Promise((resolve, reject) => {
      serviceClub
        .get("/check-has-integration")
        .then((resp) => {
          commit("userClub", resp);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  clubLogin: ({ commit, dispatch }) => {
    const serviceClub = ClubService.build();
    return new Promise((resolve, reject) => {
      serviceClub
        .get("/login")
        .then((resp) => {
          console.log('clubLogin',resp);
          let routeData =
            process.env.VUE_CLUB_API_HOST + "/?rdr=" + resp.string;
          window.open(routeData, "_blank");
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  adminUserRequest: ({ commit, dispatch }) => {
    service
      .get("")
      .then((resp) => {
        // commit('adminUserSuccess', resp);
        commit("userSuccess", resp);
        dispatch("redirectUserToHome");
      })
      .catch((err) => {
        commit("userError");
        // if resp is unauthorized, logout, to
        // dispatch('authLogout')
      });
  },
  redirectUserToHome: (context) => {
    router.push(`/dashboard${window.location.search}`).catch(() => {});
  },
  redirectUserVerification: (context) => {
    if (router.history.current.path != "/verificar-email") {
      router.push(`/verificar-email${window.location.search}`).catch(() => {});
    }
  },
  getTopbarMessage: ({ commit, dispatch }) => {
		const topbarService = TopbarService.build();
		return new Promise((resolve, reject) => {
			topbarService
				.search()
				.then((response) => {
					if (response.visible) {
						const topbarData = {
							visible: response.visible,
							type: response.type,
							message: response.message,
							link: response.link,
						};
						resolve(topbarData);
					} else {
						resolve({});
					}
				})
				.catch((err) => {
					commit("userError");
					reject(err);
				});
		});
	},  
};
